<template>
    <div class="container-fluid page">
<!--        <div class="page-subtitle">Hi {{ user.name }}</div>-->

        <div v-if="loading.reports" class="loading-big mt-5"></div>

        <template v-else>
            <div v-if="reports.length === 0" class="empty-text">
                No reports available.
            </div>
            <template v-else>
                <div v-if="reports.length > 1" class="mb-4 d-flex flex-wrap gap-2">
                    <button
                        v-for="report in reports"
                        :key="report.portalReportID"
                        class="btn btn-outline-secondary"
                        :class="{'active': selectedReportID === report.portalReportID}"
                        @click="selectReport(report)"
                    >
                        {{ report.reportTitle || report.reportName }}
                    </button>
                </div>

                <div v-if="currentState.loading" class="loading-big mt-5"></div>

                <div v-else-if="currentState.error" class="empty-text">
                    Unable to load report. Please try again.
                </div>

                <!-- One persistent container per report. v-show keeps each embed
                     alive in the DOM so switching back never reloads it. -->
                <div
                    v-for="report in reports"
                    :key="report.portalReportID"
                    v-show="selectedReportID === report.portalReportID"
                    :ref="'report-' + report.portalReportID"
                    class="report-container"
                    style="height: 750px; width: 100%;"
                ></div>
            </template>
        </template>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import * as pbi from 'powerbi-client'
import {models} from "powerbi-client";

export default {
    name: 'Reports',
    data () {
        return {
            loading: {
                reports: false,
            },
            reports: [],
            selectedReportID: null,
            // Per-report state keyed by portalReportID: { loading, error, embedded }
            reportState: {},
            powerbiService: null,
        }
    },
    computed: {
        ...mapState({
            user: state => state.user,
        }),
        currentState () {
            return this.reportState[this.selectedReportID] || {}
        },
    },
    mounted () {
        this.powerbiService = new pbi.service.Service(
            pbi.factories.hpmFactory,
            pbi.factories.wpmpFactory,
            pbi.factories.routerFactory
        )
        this.loadReports()
    },
    methods: {
        loadReports () {
            this.loading.reports = true
            this.$http.get('/UserGetReports', {
                params: {
                    // UserType: this.user.userType,
                    // userID: this.user.id,
                },
                noMessage: true,
            }).then(res => {
                this.loading.reports = false
                this.reports = res.body.apiPortalReportList || []
                if (this.reports.length > 0) {
                    this.selectReport(this.reports[0])
                }
            }).catch(() => {
                this.loading.reports = false
            })
        },
        selectReport (report) {
            const id = report.portalReportID
            this.selectedReportID = id

            // Already embedded → v-show reveals the live container, no reload.
            if (this.reportState[id] && this.reportState[id].embedded) {
                return
            }

            this.$set(this.reportState, id, { loading: true, error: false, embedded: false })
            this.$http.get('/UserGetReport', {
                params: {
                    portalReportID: id,
                    // userID: this.user.id,
                    userRole: '',
                },
                noMessage: true,
            }).then(res => {
                const state = this.reportState[id]
                state.loading = false
                if (!res.body.embedURL || !res.body.embedToken) {
                    state.error = true
                    return
                }
                this.$nextTick(() => {
                    this.embedReport(id, res.body)
                })
            }).catch(() => {
                const state = this.reportState[id]
                if (state) {
                    state.loading = false
                    state.error = true
                }
            })
        },
        embedReport (id, data) {
            const refEl = this.$refs['report-' + id]
            const container = Array.isArray(refEl) ? refEl[0] : refEl
            if (!container) return

            const config = {
                type: 'report',
                tokenType: pbi.models.TokenType.Embed,
                accessToken: data.embedToken,
                embedUrl: data.embedURL,
                pageView: 'fitToWidth',
                permissions: pbi.models.Permissions.All,
                settings: {
                    navContentPaneEnabled: data.reportConfigPageNavigation,
                    filterPaneEnabled: data.reportConfigFilters,
                    background: models.BackgroundType.Default
                }
            }
            if (data.reportConfigBookmarks) {
                if (!config.settings.panes) config.settings.panes = {}
                config.settings.panes.bookmarks = {visible: true}
            }
            if (data.reportConfigFilters) {
                if (!config.settings.panes) config.settings.panes = {}
                config.settings.panes.filters = {
                    expanded: false,
                    visible: true
                }
            }
            config.settings.background = models.BackgroundType.Default
            console.log({config});
            const report = this.powerbiService.embed(container, config)
            report.off('loaded')
            report.off('rendered')
            report.on('error', () => {
                // const state = this.reportState[id]
                // if (state) state.error = true
            })
            this.reportState[id].embedded = true
        },
    },
}
</script>
